/* eslint-disable no-redeclare */
import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

// TODO: Add validation for source
export const Source = NonEmptyText.regex(/^[0-9a-zA-Z-]*$/, 'Invalid SRC');

export type Source = z.infer<typeof Source>;
